import { render, staticRenderFns } from "./remover-ativo.vue?vue&type=template&id=d52506f6&"
import script from "./remover-ativo.vue?vue&type=script&lang=js&"
export * from "./remover-ativo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d52506f6')) {
      api.createRecord('d52506f6', component.options)
    } else {
      api.reload('d52506f6', component.options)
    }
    module.hot.accept("./remover-ativo.vue?vue&type=template&id=d52506f6&", function () {
      api.rerender('d52506f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/remover-ativo.vue"
export default component.exports